import { format } from "date-fns"

/**
 * Normalizes and formats a date string or Date object into a readable date representation.
 * Handles both ISO timestamp strings ('2026-07-15T00:00:00Z') and date-only strings ('2026-07-15').
 */
export function formatTransactionDate(
  date: string | Date,
  dateFormat: string = "dd MMM, yyyy"
): string {
  if (!date) return ""
  
  if (date instanceof Date) {
    return format(date, dateFormat)
  }

  const normalizedDate = date.includes("T") ? date : `${date}T12:00:00`
  return format(new Date(normalizedDate), dateFormat)
}

/**
 * Formats a given date into "MMMM yyyy" format (e.g. "August 2026").
 */
export function formatMonthYear(date: Date | string = new Date()): string {
  const d = typeof date === "string" ? new Date(date) : date
  return format(d, "MMMM yyyy")
}

/**
 * Formats a single date or date range into a clean representation.
 * e.g. "04 Aug, 2026" or "04 Aug → 15 Aug, 2026"
 */
export function formatTransactionDateRange(
  startDate: string | Date,
  endDate?: string | Date | null
): string {
  if (!startDate) return ""
  if (!endDate) return formatTransactionDate(startDate)

  const formattedStart = formatTransactionDate(startDate, "dd MMM, yyyy")
  const formattedEnd = formatTransactionDate(endDate, "dd MMM, yyyy")

  if (formattedStart === formattedEnd) {
    return formattedStart
  }

  return `${formattedStart} → ${formattedEnd}`
}
